import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-lead-space',
  imports: [SharedModule],
  templateUrl: './delete-lead-space.component.html',
  styleUrl: './delete-lead-space.component.scss'
})
export class DeleteLeadSpaceComponent {

  @Output() closeDialog = new EventEmitter<void>();
  @Output() reloadTabs = new EventEmitter<string>();
  @Input() activeTab: string = '';
  @Input() activeTabName: string = '';
  groupName: string = '';
  isLoading: boolean = false;

  constructor(
    private api: LeadService,
    private messageService : MessageService
  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  handleDelete(){
    const payload = {
      id: this.activeTab
    };
    this.isLoading = true;
    this.api.deleteLeadSpace(payload).subscribe({
      next: (response) => {
        this.reloadTabs.emit(this.activeTab);
        this.closeDialog.emit();
        this.isLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Group deleted successfully'
        });
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.message || 'Something went wrong'
        });
      }
    });
  }

}
